var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 161 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_303_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0913 114.735C56.5295 118.096 52.943 124.817 59.0913 124.817C65.2397 124.817 61.6531 118.096 59.0913 114.735Z",
    fill: "#507CB1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_303_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4934 120C70.9316 123.361 67.3451 130.082 73.4934 130.082C79.6418 130.082 76.0552 123.361 73.4934 120Z",
    fill: "#507CB1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_303_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.867 114.735C84.3052 118.096 80.7187 124.817 86.867 124.817C93.0153 124.817 89.4288 118.096 86.867 114.735Z",
    fill: "#507CB1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_f_303_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.6904 53.3063C73.9196 62.4993 72.7455 75.0453 78.7183 85.3905C84.6912 95.7358 96.1433 100.992 107.49 99.7247C105.077 103 101.954 105.85 98.1904 108.023C83.8641 116.295 65.6831 111.625 57.5819 97.5936C49.4808 83.5621 54.5274 65.482 68.8537 57.2107C72.6174 55.0377 76.6472 53.7579 80.6904 53.3063Z",
    fill: "#FFEE94"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_303_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3259 68.0872C64.3629 67.8674 64.3822 67.6412 64.3822 67.4103C64.3822 65.2507 62.6922 63.5 60.6074 63.5C59.0576 63.5 57.7259 64.4676 57.1446 65.8514C56.6736 65.4302 56.0625 65.1759 55.3946 65.1759C53.9055 65.1759 52.6983 66.4403 52.6983 68C52.6983 68.0869 52.7021 68.1728 52.7094 68.2576C51.9932 68.6211 51.5 69.3836 51.5 70.2655C51.5 71.4996 52.4657 72.5 53.657 72.5H63.843C65.0343 72.5 66 71.4996 66 70.2655C66 69.2034 65.2847 68.3144 64.3259 68.0872Z",
    fill: "url(#paint0_linear_303_727)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_303_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3799 92.3781C99.5485 91.4253 99.6364 90.4452 99.6364 89.4448C99.6364 80.0865 91.9438 72.5 82.4545 72.5C75.4001 72.5 69.3386 76.6928 66.6925 82.6894C64.5488 80.8641 61.7671 79.7621 58.7273 79.7621C51.9492 79.7621 46.4545 85.2412 46.4545 92C46.4545 92.3764 46.4716 92.7488 46.5049 93.1165C43.2448 94.6913 41 97.9957 41 101.817C41 107.165 45.3957 111.5 50.8182 111.5H97.1818C102.604 111.5 107 107.165 107 101.817C107 97.2148 103.744 93.3624 99.3799 92.3781Z",
    fill: "url(#paint1_linear_303_727)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_303_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.591 67.5138C109.591 68.1935 109.532 68.8595 109.42 69.5069C112.329 70.1757 114.5 72.7934 114.5 75.9207C114.5 79.5543 111.57 82.5 107.955 82.5H98.1317C95.4424 76.6047 89.4345 72.5 82.4545 72.5C77.8664 72.5 73.6983 74.2736 70.6166 77.1635C70.5401 76.761 70.5 76.3456 70.5 75.9207C70.5 73.324 71.9965 71.0787 74.17 70.0086C74.1477 69.7588 74.1364 69.5057 74.1364 69.25C74.1364 64.6575 77.7995 60.9345 82.3182 60.9345C84.3447 60.9345 86.1992 61.6833 87.6283 62.9236C89.3924 58.8489 93.4334 56 98.1364 56C104.463 56 109.591 61.1549 109.591 67.5138Z",
    fill: "url(#paint2_linear_303_727)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_303_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6973 63.2073C77.5524 61.0831 78.6783 59.0553 80.0594 57.1802C76.3686 57.5924 72.6901 58.7606 69.2544 60.7442C61.7763 65.0617 57.0681 72.3069 55.7899 80.1147C56.731 79.8842 57.7148 79.762 58.7273 79.762C61.7671 79.762 64.5488 80.864 66.6924 82.6893C67.6176 80.5928 68.9601 78.7168 70.6166 77.1634C70.5401 76.7609 70.5 76.3455 70.5 75.9206C70.5 73.3239 71.9965 71.0786 74.1699 70.0085C74.1477 69.7587 74.1363 69.5056 74.1363 69.2499C74.1363 66.8697 75.1203 64.7231 76.6973 63.2073Z",
    fill: "url(#paint3_linear_303_727)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_303_727",
    x: 55.6965,
    y: 114.735,
    width: 6.78961,
    height: 13.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_303_727",
    x: 70.0986,
    y: 120,
    width: 6.78961,
    height: 13.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_303_727",
    x: 83.4722,
    y: 114.735,
    width: 6.78961,
    height: 13.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_303_727",
    x: 0.716675,
    y: 0.306396,
    width: 159.773,
    height: 164.807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.5,
    result: "effect1_foregroundBlur_303_727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_303_727",
    x: 51.5,
    y: 63.5,
    width: 14.5,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_303_727",
    x: 41,
    y: 72.5,
    width: 66,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_303_727",
    x: 70.5,
    y: 56,
    width: 44,
    height: 36.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_303_727",
    x: 55.7899,
    y: 57.1802,
    width: 24.2695,
    height: 29.509,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_727",
    x1: 52.4223,
    y1: 71.6964,
    x2: 67.5118,
    y2: 60.9041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_727",
    x1: 45.1979,
    y1: 108.018,
    x2: 111.56,
    y2: 58.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_727",
    x1: 111.701,
    y1: 80.1339,
    x2: 66.8549,
    y2: 47.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_303_727",
    x1: 81.4051,
    y1: 52.7298,
    x2: 71.5931,
    y2: 112.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainNight);
export default __webpack_public_path__ + "static/media/Rain_Night.33cec260403f47d60518dff48e184b59.svg";
export { ForwardRef as ReactComponent };